<div class="col-12">
  <div class="row">
    <!--<div class="property-form-group">
      <mat-accordion>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>Photo</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="text-center">
            <img class="img-fluid" [src]="mainPhoto" alt="Photo principale du bien"
              appTooltip="Photo principale du bien" />
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <div *ngIf="!isOwnedChild" class="property-form-group">
      <mat-accordion>
        <mat-expansion-panel expanded>
          <mat-expansion-panel-header>
            <mat-panel-title>{{ propIsCertified() ? "Carte d'identité" : 'QR Code' }}</mat-panel-title>
          </mat-expansion-panel-header>
          <div class="d-flex justify-content-center" *ngIf="propIsCertified(); else notCertified">
            <app-property-id-card [prop]="prop"></app-property-id-card>
          </div>
          <ng-template #notCertified>
            <div class="w-100 text-center mt-lg-4">
              <a [href]="propertyHelper.getQrCodeImage(prop.uid)" [download]="prop.name + '_QRCode.png'"
                appTooltip="Télécharger le QRCode">
                <img class="img-fluid" width="240" [src]="propertyHelper.getQrCodeImage(prop.uid)"
                  alt="QRCode du bien" /></a>
            </div>
          </ng-template>
        </mat-expansion-panel>
      </mat-accordion>
    </div>-->


    <section class="property-form-group col-12 presentation" *ngIf="showPresentation">
      <mat-card class="presentation-wrap">
        <mat-card-header class="presentation-wrap-title">
          <mat-card-title>
            <h1 class="presentation-title">Présentation <mat-icon>wb_incandescent</mat-icon></h1>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content class="presentation-content">
          <div *ngIf="hasPromotionalText" class="wrap-presentation-content" [class.no-link]="!hasLinks">
            <div class="pres-content-text">{{ currentSale.promotionalText}}</div>
          </div>
          <div *ngIf="hasLinks" class="presentation-additionnals" [class.one-row]="showLinksOnOneRow">
            <ng-container *ngFor="let link of currentSale.links; let i = index">
              <a [href]="link.url" target="_blank" mat-flat-button color="primary"
                appTooltip="Ouvrir le lien {{link.name}}">{{link.name}}</a>
            </ng-container>
          </div>
        </mat-card-content>
      </mat-card>
    </section>

    <div class="property-form-group col-lg-6">
      <app-property-attribute-card title="Caractéristiques principales" [data]="summaryData"
        [linkRouterParams]="['/property', prop.uid,'infos']" tooltip="Voir toutes les caractéristiques"
        noContent="Votre bien n'est pas encore configuré."
        noContent2="Naviguez dans les différentes catégories pour entrer ses caractréristiques."
        style="min-height: 380px;"></app-property-attribute-card>
    </div>
    <div class="property-form-group col-lg-6" *ngIf="!isOwnedChild">
      <mat-card>
        <mat-card-header>
          <mat-card-title><a [routerLink]="['/property', prop.uid,'location']"
              appTooltip="Voir la localisation détaillée">Localisation</a></mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <app-new-map *ngIf="prop.location; else noMap" [props]="[prop]" defaultLayer="SATELLITE"
            [hasSatelliteView]="true" [hasPlanView]="true" [initZoom]="18"
            [hasVectorParcelles]="propHasRegistry"></app-new-map>
          <ng-template #noMap>
            <span class="no-content">Renseignez votre localisation pour visualiser la carte</span>
          </ng-template>
        </mat-card-content>
      </mat-card>
    </div>
    <ng-container *ngIf="fullMode">
      <div class="property-form-group col-lg-6" *ngIf="!isOwnedChild && !this.dpeDateError && !displayDpe2021">
        <mat-card>
          <mat-card-header>
            <mat-card-title><a [routerLink]="['/property', prop.uid,'energy']"
                appTooltip="Voir les caractéristiques énergétiques">DPE</a></mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="d-flex justify-content-center">
              <app-dpe-ges [type]="'DPE'" [value]="energyValue"></app-dpe-ges>
            </div>
          </mat-card-content></mat-card>
      </div>
      <div class="property-form-group col-lg-6" *ngIf="!isOwnedChild && !this.dpeDateError && !displayDpe2021">
        <mat-card>
          <mat-card-header>
            <mat-card-title><a [routerLink]="['/property', prop.uid,'energy']"
                appTooltip="Voir les caractéristiques énergétiques">GES</a></mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="d-flex justify-content-center">
              <app-dpe-ges [type]="'GES'" [value]="gesValue"></app-dpe-ges>
            </div>
          </mat-card-content></mat-card>
      </div>

      <div class="property-form-group col-12" *ngIf="!isOwnedChild && !this.dpeDateError && displayDpe2021">
        <mat-card>
          <mat-card-header>
            <mat-card-title><a [routerLink]="['/property', prop.uid,'energy']"
                appTooltip="Voir les caractéristiques énergétiques">DPE</a></mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="d-flex justify-content-center">
              <app-dpe-2021 [energyValue]="energyValue" [energyTag]="energyClassification" [gesValue]="gesValue"
                [gesTag]="gesClassification"></app-dpe-2021>
            </div>
          </mat-card-content></mat-card>
      </div>

      <div class="property-form-group col-12" *ngIf="!isOwnedChild && this.canUpdateProperty && this.dpeDateError">
        <mat-card>
          <mat-card-header>
            <mat-card-title><a [routerLink]="['/property', prop.uid,'energy']"
                appTooltip="Configurer les caractéristiques énergétiques">DPE</a></mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="d-flex justify-content-center">
              <p>La date indiquée pour le DPE n'a pas un format correct et n'a pas pu être analysée (les formats
                acceptés sont 01/01/2024 ou 01-01-2024).</p>
              <p><a [routerLink]="['/property', prop.uid,'energy']"
                  appTooltip="Configurer les caractéristiques énergétiques">Corrigez-là</a> pour visualiser votre DPE.
              </p>
            </div>
          </mat-card-content></mat-card>
      </div>

      <div class="property-form-group-full" *ngIf="childrenProp.length>0">
        <mat-card>
          <mat-card-header>
            <mat-card-title>Biens liés</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <div class="d-flex justify-content-center">
              <ng-container *ngFor="let child of childrenProp">
                <app-property-card class="col-6 col-lg-6 col-xl-6 p-3" [prop]="child" [showOwnerName]="false"
                  [showAddress]="false">
                </app-property-card>
              </ng-container>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </ng-container>
  </div>
</div>